// This file is mainly just for cleaning up the exports to be intuitive/commonjs
module.exports = require('./dist')
